import React from 'react';
import { Provider } from 'react-redux';

import Base from './Base.jsx';

import HeadlineAnalysisList from '../Components/HeadlineAnalysisList/index.jsx';

import HeadlineAnalysisService from '../Services/HeadlineAnalysis/index.jsx';

import Store from '../Store/index.js';


class EntryPoint extends Base {
  id() {
    return 'cs-headline-analysis';
  }

  renderElement(element) {
    return (
      <Provider store={Store}>
        <HeadlineAnalysisList headlineAnalysisService={HeadlineAnalysisService} />
      </Provider>
    );
  }
}


export default EntryPoint;

